"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

var _withStyles = _interopRequireDefault(require("@material-ui/core/styles/withStyles"));

var _classnames = _interopRequireDefault(require("classnames"));

var _capitalize = _interopRequireDefault(require("lodash/capitalize"));

var _styles = _interopRequireDefault(require("./styles"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var Footer = function Footer(_ref) {
  var classes = _ref.classes,
      color = _ref.color,
      className = _ref.className,
      children = _ref.children;
  return React.createElement("div", {
    className: (0, _classnames.default)(classes.footer, _defineProperty({}, classes["color".concat((0, _capitalize.default)(color))], color !== 'inherit'), className)
  }, children);
};

Footer.defaultProps = {
  classes: {},
  color: 'inherit',
  className: ''
};

var _default = (0, _withStyles.default)(_styles.default)(React.memo(Footer));

exports.default = _default;